// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"406":"0b56b49c","727":"321512bb"}[chunkId] + ".css";
};